import React from 'react';

import { Skeleton, SkeletonTheme, UiKit } from 'components';
import { useRequestReasonConfig } from '../context';

export default function Loader({ children = null }) {
  const { isLoading } = useRequestReasonConfig();

  if (!isLoading) return children;

  const units = Array.from({ length: 6 }).map((_, index) => (
    <UiKit.Chip key={index} size="sm" className="cursor-not-allowed">
      <UiKit.Flex gap={4} align="center">
        <Skeleton width={16} height={24} />
        <Skeleton width={44} height={24} />
      </UiKit.Flex>
    </UiKit.Chip>
  ));

  return (
    <SkeletonTheme className="m-0">
      <UiKit.Flex direction="column" gap={24}>
        <UiKit.Flex direction="column" gap={4}>
          <Skeleton height="16px" width="50px" className="my-1" />
          <Skeleton height="34px" width="100%" />
        </UiKit.Flex>
        <UiKit.Flex direction="column" gap={8}>
          <Skeleton height="18px" width="120px" />
          <UiKit.Grid gap={16}>{units}</UiKit.Grid>
        </UiKit.Flex>
      </UiKit.Flex>
    </SkeletonTheme>
  );
}
